<template>
    <div class="public_container m_customer_seas_detail" v-loading="loading">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"> </ReturnNavBar>
            <div class="returnNavBarRight">
                <i class="iconfont icon-gengduo1" @click="moreFunctionVisible = true"></i>
            </div>
        </div>
        <div class="mobile_container">
            <div class="detail_info_card">
                <div class="detail_info_card_top">
                    <p class="ellipsis">{{ details.name }}</p>
                    <p>
                        <span v-if="customerDetail.country_region">{{ customerDetail.country_region.text }}</span
                        ><span></span>
                    </p>
                </div>
                <div class="detail_info_card_bottom">
                    <p>
                        商机：总{{ customerSummaryData.project && customerSummaryData.project.project_count }}/赢{{
                            customerSummaryData.project && customerSummaryData.project.project_win
                        }}/输{{ customerSummaryData.project && customerSummaryData.project.project_failed }}
                    </p>
                    <p>订单总额：{{ customerSummaryData.total_order_amount }}元</p>
                    <p>已回款：{{ customerSummaryData.total_repaid_amount }}元</p>
                    <p>未回款：{{ customerSummaryData.total_unrepaid_amount }}元</p>
                </div>
            </div>
            <ul class="detail_info_tab">
                <li
                    v-for="item in detailTab"
                    :key="item.type"
                    :class="{ active: activeTab == item.tab }"
                    @click="handleClickChangeTab(item)"
                >
                    {{ item.title }}
                </li>
            </ul>
            <div class="detail_info_tab1_content" v-if="activeTab == 'detail'">
                <CustomFormDetailMobile
                    v-if="dataLoaded"
                    ref="customFormPc"
                    :field_list="formInfoList"
                    :form_detail="customerDetail"
                    :pk_id="customer_id ? Number(customer_id) : 0"
                    :is_edit_mode="false"
                />
            </div>
            <div class="detail_info_tab2_content" v-else-if="activeTab == 'log'">
                <div class="detail_filter_wrap">
                    <div class="detail_filter_type_btn" @click="handleClickLogTypeShow">
                        <span>{{ dynamicFilterForm.typeName || "筛选类型" }}</span>
                        <van-icon name="arrow-down" />
                    </div>
                    <i class="iconfont icon-rili_qujian" @click="handleDateShow"></i>
                </div>
                <div class="detail_filter_list" v-loading="dynamicLoading">
                    <van-pull-refresh @refresh="onPullRefreshList" success-text="刷新成功" v-model="pullLoading">
                        <van-list
                            :immediate-check="false"
                            :finished="finishedList"
                            @load="getCustomerLogList"
                            finished-text="——已经到底了——"
                            v-model="listLoading"
                        >
                            <ul class="dynamic_list">
                                <li class="dynamic_item" v-for="item in dynamicList" :key="item.id">
                                    <div class="dynamic_item_title">
                                        <div class="img_wrap">
                                            <img
                                                :src="
                                                    item.log_user && item.log_user.avatar
                                                        ? item.log_user.avatar
                                                        : defaultImg
                                                "
                                                alt=""
                                            />
                                        </div>
                                        <span class="dynamic_item_name">{{ item.log_user && item.log_user.name }}</span>
                                        <span class="dynamic_item_time">{{ item.created_date }}</span>
                                        <span
                                            v-if="dynamicTypeTagList.includes(item.type)"
                                            :class="['dynamic-tag', 'dynamic-tag-' + item.type]"
                                            >{{ item.type_name }}</span
                                        >
                                    </div>
                                    <div class="dynamic_item_content">
                                        <template v-if="item.type == 'project_add'">
                                            <template v-if="item.content && item.content.content">
                                                <span
                                                    class="link-label"
                                                    @click="
                                                        handleClickBusinessDetail(
                                                            item.relate_id,
                                                            item.content.content.project_name
                                                        )
                                                    "
                                                    >{{ item.content.content.project_name }}</span
                                                >
                                                <span>{{ item.content.content.project_stage_name }}</span>
                                            </template>
                                        </template>
                                        <template v-else-if="item.type == 'new_work_order'">
                                            <span class="link-label">{{
                                                item.content &&
                                                item.content.content &&
                                                item.content.content.workorder_num
                                            }}</span>
                                            <span>{{
                                                item.content &&
                                                item.content.content &&
                                                item.content.content.workorder_status_text
                                            }}</span>
                                            <span>{{
                                                item.content &&
                                                item.content.content &&
                                                item.content.content.workorder_type_text
                                            }}</span>
                                        </template>
                                        <template v-else-if="item.type == 'order_add'">
                                            <span
                                                class="link-label"
                                                @click="handleClickLogOrderDetail(item.content && item.content.content)"
                                                >{{
                                                    item.content &&
                                                    item.content.content &&
                                                    item.content.content.order_num
                                                }}</span
                                            >
                                            <span
                                                >{{
                                                    item.content &&
                                                    item.content.content &&
                                                    item.content.content.salesperson &&
                                                    item.content.content.salesperson.name
                                                }}
                                            </span>
                                            <span
                                                >¥{{
                                                    item.content &&
                                                    item.content.content &&
                                                    item.content.content.total_price
                                                }}</span
                                            >
                                        </template>
                                        <template v-else-if="item.type == 'manage'">
                                            <p>{{ item.content && item.content.content }}</p>
                                            <template
                                                v-if="item.is_open && item.extendDetail"
                                                v-loading="manageCustomerDetailLoading"
                                            >
                                            </template>
                                            <div
                                                class="is-collapsed-down"
                                                :class="{ 'is-collapsed-up': item.is_open }"
                                                @click="handleClickCollapsed(item)"
                                            >
                                                <span>{{ item.is_open ? "收起" : "展开" }}</span
                                                ><img
                                                    src="https://download.hecoos.com/enlightv/2024-45/5dcd224158f9ca176d74045d01d456e8.png"
                                                    alt=""
                                                />
                                            </div>
                                        </template>
                                        <template v-else-if="item.type == 'change'">
                                            <span>客户等级：</span>
                                            <span>A级—B级</span>
                                        </template>
                                        <template v-else-if="item.type == 'follow_up'">
                                            <p class="ellipsis_2">
                                                {{ item.content && item.content.content }}
                                            </p>
                                            <div class="is-collapsed-down" @click="handleClickFollowRecordDetail(item)">
                                                <span>详情</span
                                                ><img
                                                    src="https://download.hecoos.com/enlightv/2024-45/d773cf7f7e8c2899137cf875c60da210.png"
                                                    alt=""
                                                />
                                            </div>
                                        </template>
                                        <template v-else>
                                            <template v-if="item.type_detail == 'edit_customer'">
                                                <span>{{ item.type_name }}</span>
                                            </template>
                                            <span v-else>{{ item.content && item.content.content }}</span>
                                        </template>
                                    </div>
                                </li>
                            </ul>
                        </van-list>
                    </van-pull-refresh>
                </div>
            </div>
            <div class="detail_info_tab3_content" v-else>
                <div class="card_info_item card_info_item_contact" v-loading="contactLoading">
                    <div class="card_info_item_title">联系人（{{ contactList.length }}）</div>
                    <div class="card_info_item_content">
                        <ul>
                            <li v-for="item in showContactList" :key="item.id">
                                <img
                                    class="contact_icon"
                                    src="https://download.hecoos.com/enlightv/2024-48/a5e8c21ca31b69aa8380f7e4bfb6ada6.png"
                                    alt=""
                                />
                                <span class="ellipsis">{{ item.name }}</span>
                            </li>
                        </ul>
                        <div
                            class="card_info_item_open"
                            @click="handlecontactIsExpandedChange"
                            v-if="contactList.length > 2"
                        >
                            <span>{{ contactIsExpanded ? "收起" : "展开" }}</span>
                            <van-icon name="arrow-up" v-if="contactIsExpanded" />
                            <van-icon name="arrow-down" v-else />
                        </div>
                    </div>
                </div>
                <div class="card_info_item card_info_item_order" v-loading="orderListLoading">
                    <div class="card_info_item_title">关联订单（{{ relatedOrderList.length }}）</div>
                    <div class="card_info_item_content">
                        <ul>
                            <li v-for="item in showOrderList" :key="item.id">
                                <div>
                                    <p @click="handleClickOrderDetail(item)">
                                        <i class="iconfont icon-a-dingdan1"></i
                                        ><span class="ellipsis">{{ item.order_num }}</span>
                                    </p>
                                    <span>¥{{ item.total_price }}</span>
                                </div>
                                <div>
                                    <div class="user_avatar_btn">
                                        <img
                                            :src="
                                                item.salesperson && item.salesperson.avatar
                                                    ? item.salesperson.avatar
                                                    : defaultImg
                                            "
                                            alt=""
                                        />
                                        <span>{{ item.salesperson && item.salesperson.name }}</span>
                                    </div>
                                    <span>{{ item.created_at }}</span>
                                </div>
                            </li>
                        </ul>
                        <div
                            class="card_info_item_open"
                            @click="handleOrderIsExpandedChange"
                            v-if="relatedOrderList.length > 2"
                        >
                            <span>{{ orderIsExpanded ? "收起" : "展开" }}</span>
                            <van-icon name="arrow-up" v-if="orderIsExpanded" />
                            <van-icon name="arrow-down" v-else />
                        </div>
                    </div>
                </div>
                <div class="card_info_item card_info_item_projects" v-loading="projectsListLoading">
                    <div class="card_info_item_title">关联商机（{{ relatedProjectsList.length }}）</div>
                    <div class="card_info_item_content">
                        <ul>
                            <li v-for="item in showProjectsList" :key="item.id">
                                <p @click="handleClickBusinessDetail(item.id, item.name)">
                                    <i class="iconfont icon-shangji"></i><span class="ellipsis">{{ item.name }}</span>
                                </p>
                                <span>{{ item.stage_detail && item.stage_detail.name }}</span>
                            </li>
                        </ul>
                        <div
                            class="card_info_item_open"
                            @click="handleProjectsIsExpandedChange"
                            v-if="relatedProjectsList.length > 2"
                        >
                            <span>{{ projectsIsExpanded ? "收起" : "展开" }}</span>
                            <van-icon name="arrow-up" v-if="projectsIsExpanded" />
                            <van-icon name="arrow-down" v-else />
                        </div>
                    </div>
                </div>
                <div class="card_info_item card_info_item_work" v-loading="workOrderListLoading">
                    <div class="card_info_item_title">关联工单（{{ workOrderPagination.total }}）</div>
                    <div class="card_info_item_content" style="max-height: 500px; overflow-y: auto">
                        <ul v-infinite-scroll="workOrderListLoadMore">
                            <li v-for="item in showWorksList" :key="item.id">
                                <div>
                                    <p @click="handleClickWorkOrderDetail(item)">
                                        <i class="iconfont icon-shangji"></i
                                        ><span class="ellipsis">{{ item.workorder_num }}</span>
                                    </p>
                                    <span>{{ item.workorder_type_id && item.workorder_type_id.name }}</span>
                                </div>
                                <p>发布于{{ item.created_at }}</p>
                            </li>
                        </ul>
                        <div
                            class="card_info_item_open"
                            @click="handleWorksIsExpandedChange"
                            v-if="relatedWorkOrderList.length > 2"
                        >
                            <span>{{ worksIsExpanded ? "收起" : "展开" }}</span>
                            <van-icon name="arrow-up" v-if="worksIsExpanded" />
                            <van-icon name="arrow-down" v-else />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 日志类型筛选 -->
        <van-overlay
            :custom-style="{ background: 'rgba(0, 0, 0, 0.3)', zIndex: 99999 }"
            v-if="logTypeVisible"
            :show="logTypeVisible"
        >
            <div class="radio_option_wrap">
                <ul class="radio_option_list">
                    <li
                        v-for="item in logTypeOptions"
                        class="radio_option_item"
                        @click="handleLogTypeConfirm(item)"
                        v-text="item.name"
                    ></li>
                </ul>
                <div class="cancel_btn" @click="logTypeVisible = false">取消</div>
            </div>
        </van-overlay>
        <van-calendar
            v-model="showDateCalendar"
            type="range"
            color="#2990FF"
            :min-date="dateCalendarMin"
            :max-date="dateCalendarMax"
            @confirm="handleDateCalenderConfirm"
        />
        <van-popup
            :value="moreFunctionVisible"
            round
            position="bottom"
            :style="{ height: '278px' }"
            @click-overlay="handleClosePopup"
            v-if="moreFunctionVisible"
        >
            <div class="more_function_wrap">
                <p class="more_function_wrap_title">更多功能</p>
                <ul class="more_function_card1">
                    <li v-for="item in moreFunctionCardList1" :key="item.type" @click="handleClickMoreFunction(item)">
                        <i :class="['iconfont', item.icon]"></i>
                        <span>{{ item.title }}</span>
                    </li>
                </ul>
                <ul class="more_function_card2">
                    <li v-for="item in moreFunctionCardList2" :key="item.type" @click="handleClickMoreFunction(item)">
                        <span>{{ item.title }}</span>
                        <i :class="['iconfont', item.icon]"></i>
                    </li>
                </ul>
            </div>
        </van-popup>
        <CustomerApply
            v-if="customerApplyPopupShow"
            :customerApplyPopupShow.sync="customerApplyPopupShow"
            :sea_id="sea_id"
            :companyList="selectedList"
            @applySuccess="handleClickChangeTab({ tab: 'detail' })"
        />
        <CustomerAllocation
            v-if="customerAllocationPopupShow"
            :customerAllocationPopupShow.sync="customerAllocationPopupShow"
            :sea_id="sea_id"
            :companyList="selectedList"
            @allocationSuccess="handleClickChangeTab({ tab: 'detail' })"
        />
        <CustomerTransfer
            v-if="customerTransferPopupShow"
            :customerTransferPopupShow.sync="customerTransferPopupShow"
            :sea_id="sea_id"
            :companyList="selectedList"
            @transferSuccess="handleClickChangeTab({ tab: 'detail' })"
        />
        <RelatedContactAdd
            v-if="contactAddPopupShow"
            :contactAddPopupShow.sync="contactAddPopupShow"
            :customer_id="Number(customer_id)"
            @contactAddSuccess="getContactList"
        />
    </div>
</template>

<script>
import { pagination } from "@/mixins";
import { formatDate } from "@/utils";
import { Dialog } from "vant";
import {
    GetContactList,
    GetCustomerPublicDetail,
    CustomerPublicDel,
    GetCustomerLogTypeList,
    GetCustomerLogList,
    getFormFields,
    ContactAdd,
    GetCompanySwitchList,
    CustomerSummary,
    CustomerRelateOrders,
    CustomerRelateProjects,
    checkClaimNum,
    getWorkOrderList
} from "@/api";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import CustomFormDetailMobile from "@/components/mComponents/CustomFormDetailMobile";
import CustomerApply from "./customer_apply.vue";
import CustomerAllocation from "./customer_allocation.vue";
import CustomerTransfer from "./customer_transfer.vue";
import RelatedContactAdd from "./component/contact_add.vue";
export default {
    name: "CustomerHighSeasDetail",
    components: {
        ReturnNavBar,
        CustomFormDetailMobile,
        CustomerApply,
        CustomerAllocation,
        CustomerTransfer,
        RelatedContactAdd,
    },
    data() {
        return {
            loading: false,
            defaultImg: require("@/assets/images/default.jpg"),
            customer_id: this.$route.query.customer_id,
            sea_id: this.$route.query.sea_id,
            details: {
                name: "",
            },
            customerDetail: {},
            editDetailsShow: true,
            dataLoaded: false,
            formInfoList: [],

            // 客户摘要信息
            customerSummaryData: {
                project: {},
                order_count: 0,
                total_order_amount: 0,
                total_repaid_amount: 0,
                total_unrepaid_amount: 0,
            },

            activeTab: "detail",
            detailTab: [
                { tab: "detail", title: "客户详情" },
                { tab: "log", title: "历史动态" },
                { tab: "relateInfo", title: "关联信息" },
            ],
            dynamicLoading: false,
            dynamicFilterForm: {
                type: "",
                typeName: "",
                dateRange: [],
                page: 1,
                total: 0,
                modelSwitch: {
                    customer_follow_ups: "",
                    customer_manages: "",
                },
            },
            logTypeVisible: false,
            logTypeOptions: [],
            showDateCalendar: false,
            dateCalendarMin: new Date("1970-01-01"),
            dateCalendarMax: new Date("2070-01-01"),
            dynamicTypeTagList: [
                "follow_up",
                "manage",
                "project_add",
                "order_add",
                "new_work_order",
                "customer_change",
            ],
            pullLoading: false,
            finishedList: false,
            listLoading: false,
            dynamicList: [],

            contactLoading: false,
            contactIsExpanded: false, // 是否展开
            contactList: [],
            orderListLoading: false,
            orderIsExpanded: false,
            relatedOrderList: [],
            projectsListLoading: false,
            projectsIsExpanded: false,
            relatedProjectsList: [],
            worksIsExpanded: false,
            workOrderPagination: {
                pageNum: 1,
                pageSize: 10,
                total: 0,
            },
            workOrderListLoading: false,
            relatedWorkOrderList: [],

            moreFunctionVisible: false,
            moreFunctionCardList1: [
                { type: "edit", title: "编辑客户", icon: "icon-bianji" },
                { type: "apply", title: "申领客户", icon: "icon-shenling" },
                { type: "allocation", title: "分配客户", icon: "icon-fenpei" },
                { type: "transfer", title: "转移客户", icon: "icon-qiehuan" },
            ],
            moreFunctionCardList2: [
                { type: "addContact", title: "新增联系人", icon: "icon-a-shenling1" },
                { type: "share", title: "分享", icon: "icon-fenxiang" },
                { type: "delete", title: "删除", icon: "icon-shanchu1" },
            ],
            moreFunctionType: "", // 更多功能类型
            manageCustomerDetailLoading: false,

            // 申领
            customerApplyPopupShow: false,
            // 分配
            customerAllocationPopupShow: false,
            // 转移
            customerTransferPopupShow: false,
            // 新增联系人
            contactAddPopupShow: false,
            selectedList: [],
        };
    },
    mixins: [pagination],
    computed: {
        showContactList() {
            if (this.contactIsExpanded) {
                return this.contactList;
            } else {
                return this.contactList.slice(0, 2);
            }
        },
        showOrderList() {
            if (this.orderIsExpanded) {
                return this.relatedOrderList;
            } else {
                return this.relatedOrderList.slice(0, 2);
            }
        },
        showProjectsList() {
            if (this.projectsIsExpanded) {
                return this.relatedProjectsList;
            } else {
                return this.relatedProjectsList.slice(0, 2);
            }
        },
        showWorksList() {
            if (this.worksIsExpanded) {
                return this.relatedWorkOrderList;
            } else {
                return this.relatedWorkOrderList.slice(0, 2);
            }
        },
    },
    created() {
        this.loading = true;
        this.moreFunctionVisible = false;
        if (this.$route.query) {
            this.details.name = this.$route.query.name;
        }
        this.getLocalStorageFunction();
    },
    methods: {
        // 读取缓存
        getLocalStorageFunction() {
            let localStorageData = localStorage.getItem("customerHighSeasDetail");
            if (localStorageData) {
                localStorageData = JSON.parse(localStorageData);
                this.details.name = localStorageData.name;
                this.customer_id = localStorageData.customer_id;
                this.sea_id = localStorageData.sea_id;
            }
            this._getFromFields();
            localStorage.removeItem("customerHighSeasDetail");
        },
        // 写入缓存
        setLocalStorageFunction() {
            const params = {
                name: this.details.name,
                customer_id: this.customer_id,
                sea_id: this.sea_id,
            };
            localStorage.setItem("customerHighSeasDetail", JSON.stringify(params));
        },
        handleClickChangeTab({ tab }) {
            this.activeTab = tab;
            if (tab === "detail") {
                this.getCustomerPublicDetail();
            } else if (tab === "log") {
                this.getCustomerLogTypeList();
                this.getCompanySwitchList();
            } else {
                this.getContactList();
                this.getCustomerRelateOrders();
                this.getCustomerRelateProjects();
                this.getCustomerRelateWorkOrderListData()
            }
            this.getCustomerSummary();
        },
        _getFromFields() {
            this.loading = true;
            getFormFields({
                field_form: "customers",
            })
                .then((res) => {
                    if (res.code === 200) {
                        this.formInfoList = res.data;
                        if (this.customer_id) {
                            this.getCustomerPublicDetail();
                            this.getCustomerSummary();
                        }
                    } else {
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 获取客户详情
        getCustomerPublicDetail() {
            GetCustomerPublicDetail(this.customer_id).then((res) => {
                if (res.code === 200) {
                    this.customerDetail = JSON.parse(JSON.stringify(res.data));
                    this.project_ids = this.customerDetail.project_ids;
                    this.order_ids = this.customerDetail.order_ids;
                    this.editDetailsShow = false;
                    this.dataLoaded = false;
                    this.$nextTick(() => {
                        this.editDetailsShow = true;
                        this.dataLoaded = true;
                    });
                    this.loading = false;
                } else {
                    this.loading = false;
                }
            });
        },
        // 获取客户摘要
        getCustomerSummary() {
            const params = {
                customer_id: this.customer_id,
            };
            CustomerSummary(params).then((res) => {
                if (res.code === 200) {
                    this.customerSummaryData = res.data || {};
                }
            });
        },
        // 获取关联订单
        getCustomerRelateOrders() {
            const params = {
                customer_id: this.customer_id,
            };
            CustomerRelateOrders(params).then((res) => {
                if (res.code === 200) {
                    const data = res.data || [];
                    this.relatedOrderList = data.map((item) => {
                        item.created_at = item.created_at ? formatDate(item.created_at, "date") : item.created_at;
                        return item;
                    });
                } else {
                    this.relatedOrderList = [];
                }
            });
        },
        // 获取关联商机
        getCustomerRelateProjects() {
            const params = {
                customer_id: this.customer_id,
            };
            CustomerRelateProjects(params).then((res) => {
                if (res.code === 200) {
                    this.relatedProjectsList = res.data || [];
                } else {
                    this.relatedProjectsList = [];
                }
            });
        },
        // 获取跟进记录和管理记录开关状态
        getCompanySwitchList() {
            GetCompanySwitchList().then((res) => {
                if (res.code === 200) {
                    const data = res.data || [];
                    data.forEach((item) => {
                        this.dynamicFilterForm.modelSwitch[item.type] = item.status;
                    });
                    this.onPullRefreshList();
                } else {
                    this.loading = false;
                }
            });
        },
        // 日志类型筛选
        handleClickLogTypeShow() {
            this.logTypeVisible = true;
        },
        handleLogTypeConfirm(item) {
            this.dynamicFilterForm.type = item.value;
            this.dynamicFilterForm.typeName = item.name;
            this.logTypeVisible = false;
            this.onPullRefreshList();
        },
        handleLogTypeCancel() {
            this.logTypeVisible = false;
        },
        handleDateShow() {
            this.showDateCalendar = true;
        },
        handleDateCalenderConfirm(date) {
            const newDate = date ? [formatDate(date[0], "date"), formatDate(date[1], "date")] : [];
            this.dynamicFilterForm.dateRange = newDate;
            this.showDateCalendar = false;
            this.onPullRefreshList();
        },
        // 获取日志类型
        getCustomerLogTypeList() {
            GetCustomerLogTypeList().then((res) => {
                if (res.code === 200) {
                    const data = res.data || [];
                    this.logTypeOptions = data.map((item) => ({ name: item.title, value: item.value }));
                    // this.logTypeOptions.unshift({ name: "全部", value: "" });
                    this.loading = false;
                } else {
                    this.loading = false;
                }
            });
        },
        onPullRefreshList() {
            this.dynamicLoading = true;
            this.pagination.pageNum = 1;
            this.finishedList = false;
            this.dynamicList = [];
            this.getCustomerLogList();
        },
        // 获取日志信息
        getCustomerLogList() {
            if (this.finishedList) return;
            this.finishedList = true;
            const params = {
                keyword: "",
                customer_id: this.customer_id,
                type: this.dynamicFilterForm.type,
                dateRange:
                    this.dynamicFilterForm.dateRange && this.dynamicFilterForm.dateRange.length
                        ? this.dynamicFilterForm.dateRange.join(" - ")
                        : "",
                page: this.pagination.pageNum,
                pageSize: 10,
                modelSwitch: this.dynamicFilterForm.modelSwitch,
            };
            GetCustomerLogList(params).then((res) => {
                if (res.code === 200) {
                    const { list, total } = res.data;
                    this.dynamicList = this.dynamicList.concat(list || []);
                    this.dynamicFilterForm.total = Number(total);
                    this.pullLoading = this.listLoading = false; // 加载和下拉状态结束
                    this.finishedList = list.length === 0; //上滑列表加载完了所有数据（没有更多了）
                    this.dynamicLoading = false;
                    this.pagination.pageNum++;
                } else {
                    this.dynamicLoading = false;
                    this.$toast({
                        message: res.message,
                        type: "fail",
                    });
                }
            });
        },
        // 获取联系人列表
        getContactList() {
            this.contactLoading = true;
            GetContactList({ name: "", customer_id: this.customer_id }).then((res) => {
                if (res.code === 200) {
                    const { list, total } = res.data;
                    this.contactList = list || [];
                } else {
                    this.contactList = [];
                }
                this.contactLoading = false;
            });
        },
        // 加载更多工单信息
        workOrderListLoadMore() {
            if (this.workOrderListLoading || this.relatedWorkOrderList.length == this.workOrderPagination.total) {
                return false;
            }
            this.workOrderPagination.pageNum += 1;
            this.getCustomerRelateWorkOrderListData();
        },
        // 获取关联工单
        getCustomerRelateWorkOrderListData() {
            this.workOrderListLoading = true;
            getWorkOrderList({
                page: this.workOrderPagination.pageNum,
                pageSize: this.workOrderPagination.pageSize,
                keyword: "",
                tab: "",
                project_id: this.project_ids,
                order_id: this.order_ids && this.order_ids.length ? this.order_ids.join(",") : "",
            }).then((res) => {
                if (res.code === 200) {
                    const { data, total } = res.data;
                    data.forEach((item) => {
                        this.$set(item, "workorder_id", item.id);
                    });
                    this.workOrderListLoading = false;
                    this.relatedWorkOrderList = this.relatedWorkOrderList.concat(data || []);
                    this.workOrderPagination.total = total;
                } else {
                    this.workOrderListLoading = false;
                }
            });
        },
        handlecontactIsExpandedChange() {
            this.contactIsExpanded = !this.contactIsExpanded;
        },
        handleOrderIsExpandedChange() {
            this.orderIsExpanded = !this.orderIsExpanded;
        },
        handleProjectsIsExpandedChange() {
            this.projectsIsExpanded = !this.projectsIsExpanded;
        },
        handleWorksIsExpandedChange() {
            this.worksIsExpanded = !this.worksIsExpanded;
        },
        // 操作更多功能
        handleClosePopup() {
            this.moreFunctionVisible = false;
        },
        handleClickMoreFunction({ type }) {
            this.moreFunctionType = type;
            if (type === "allocation" || type === "transfer" || type === "apply") {
                const selectedList = [{ id: this.customer_id, name: { value: this.details.name } }];
                this.selectedList = selectedList;
                this.moreFunctionVisible = false;
            }
            switch (type) {
                case "edit":
                    // 编辑
                    this.moreFunctionVisible = false;
                    this.$router.push({
                        name: "MCustomerEdit",
                        query: {
                            id: this.customer_id,
                            addType: "private",
                            sea_id: this.sea_id,
                        },
                    });
                    break;
                case "allocation":
                    // 分配
                    this.moreFunctionVisible = false;
                    this.customerAllocationPopupShow = true;
                    break;
                case "transfer":
                    // 转移
                    this.moreFunctionVisible = false;
                    this.customerTransferPopupShow = true;
                    break;
                case "delete":
                    Dialog.confirm({
                        title: "提示",
                        message: `确定<span class="text_red">删除</span>选中的客户吗？`,
                        className: "my_dialog",
                        confirmButtonColor: "rgba(41, 144, 255, 1)",
                        confirmButtonText: "确定",
                    })
                        .then(() => {
                            CustomerPublicDel({ customer_ids: [this.customer_id] }).then((res) => {
                                if (res.code === 200) {
                                    this.$toast({
                                        message: res.message,
                                        type: "success",
                                        duration: 1000,
                                        onClose: () => {
                                            this.$router.go(-1);
                                        },
                                    });
                                } else {
                                    this.$toast({
                                        message: res.message,
                                        type: "fail",
                                    });
                                }
                            });
                        })
                        .catch(() => {
                            // on cancel
                        });
                    break;
                case "share":
                    // 分享
                    this.moreFunctionVisible = false;
                    const name =
                        this.$store.state.userInfo &&
                        this.$store.state.userInfo.user &&
                        this.$store.state.userInfo.user.name;
                    this.$router.push({
                        name: "MCustomerShareTpl",
                        query: {
                            customer_id: this.customer_id,
                            cname: this.details.name,
                            name: name,
                            type: 1,
                        },
                    });
                    break;
                case "apply":
                    // 申领
                    checkClaimNum({ sea_id: this.sea_id, customer_ids: this.selectedList.map((item) => item.id) }).then(
                        (res) => {
                            if (res.code === 200) {
                                this.moreFunctionVisible = false;
                                this.customerApplyPopupShow = true;
                            }
                        }
                    );
                    break;
                case "addContact":
                    // 新增联系人
                    this.moreFunctionVisible = false;
                    this.contactAddPopupShow = true;
                    break;
            }
        },
        // 展开和收起
        async handleClickCollapsed(item) {
            this.manageCustomerDetailLoading = true;
            if (!item.hasOwnProperty("is_open")) {
                await this.getCustomerManageDetail(item);
                this.$set(item, "is_open", true);
            } else {
                item.is_open = !item.is_open;
            }
        },
        // 查看管理记录详情
        getCustomerManageDetail(item) {
            GetCustomerManageDetail(item.relate_id).then((res) => {
                if (res.code === 200) {
                    this.$set(item, "extendDetail", res.data || {});
                }
            });
        },
        // 跟进客户详情
        handleClickFollowRecordDetail(item) {},
        //点击查看商机详情
        handleClickBusinessDetail(project_id, name) {
            this.$router.push({
                name: "BusinessDetail",
                params: {
                    isPush: true,
                },
                query: {
                    project_id: project_id,
                    name: name,
                },
            });
        },
        // 订单详情
        handleClickOrderDetail(row) {
            this.$router.push({
                name: "OrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    order_id: row.id ? row.id : undefined,
                    order_num: row.order_no ? row.order_no : undefined,
                    name: row.order_num ? row.order_num : row.order_no,
                    query_type: row.id ? undefined : "order_num",
                },
            });
        },
        //工单详情
        handleClickWorkOrderDetail(row) {
            this.$router.push({
                name: "WorkOrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    work_order_id: row.id,
                    name: row.workorder_num,
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/styles/m_style/customer-detail.scss";
</style>
<style lang="scss">
.more_function_wrap {
    width: 100%;
    height: 100%;
    background-color: rgba(247, 248, 250, 1);
    padding: 0 16px 10px;
    .more_function_wrap_title {
        padding: 12px 0;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0px;
        line-height: 24px;
        color: rgba(51, 51, 51, 1);
    }
    .more_function_card1 {
        display: flex;
        li {
            padding: 15px 0 10px;
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 5px;
            .iconfont {
                font-size: 22px;
                padding: 1px;
                color: rgba(122, 176, 235, 1);
            }
            span {
                font-size: 14px;
                font-weight: 500;
                letter-spacing: 0px;
                line-height: 22px;
                color: rgba(51, 51, 51, 1);
            }
            &:active,
            &.active {
                border-radius: 8px;
                background: rgba(255, 255, 255, 1);
            }
        }
    }
    .more_function_card2 {
        margin-top: 10px;
        border-radius: 8px;
        background: rgba(255, 255, 255, 1);
        li {
            height: 44px;
            padding: 0 10px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            &:not(:last-child) {
                border-bottom: 1px solid rgba(247, 248, 250, 1);
            }
            span {
                font-size: 14px;
                font-weight: 500;
                letter-spacing: 0px;
                line-height: 22px;
                color: rgba(51, 51, 51, 1);
            }
            .iconfont {
                font-size: 20px;
                color: rgba(122, 176, 235, 1);
            }
        }
    }
}
</style>
